import React from 'react';
import siteContent from '../../data/siteContent';
import SectionTitle from '../common/SectionTitle';

function DifferentialsSection() {
  return (
    <section id="contato">
      <div className="container center">
        <SectionTitle
          label={siteContent.differentials.label}
          title={siteContent.differentials.title}
          accent={siteContent.differentials.titleAccent}
          center
        />

        <div className="why-grid">
          {siteContent.differentials.items.map((item) => (
            <div className="wcard reveal" key={item.number}>
              <div className="w-num">{item.number}</div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DifferentialsSection;